import { buildQueryString, request, serializeCsvQuery } from "../../client"
import {
  archiveRegistryRoots,
  restoreRegistryRoots,
  type RegistryArchiveBatchResponse,
} from "../../archive"

export const fetchPropertyUnits = (query?: PropertyUnitQuery) =>
  request<PropertyUnit[]>(
    `/unit-registry/property-units${buildQueryString({
      property_id: query?.propertyId,
      property_ids: serializeCsvQuery(query?.propertyIds),
      organization_id: query?.organizationId,
      archive_scope: query?.archiveScope,
    })}`,
  )

export const createPropertyUnit = (payload: PropertyUnitCreatePayload) =>
  request<PropertyUnit>("/unit-registry/property-units", {
    method: "POST",
    body: JSON.stringify(payload),
  })

export const updatePropertyUnit = (unitId: string, payload: PropertyUnitUpdatePayload) =>
  request<PropertyUnit>(`/unit-registry/property-units/${unitId}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  })

export const archivePropertyUnitsBatch = (
  unitIds: string[],
  reason: ArchiveReason = "USER_REQUEST",
): Promise<RegistryArchiveBatchResponse> =>
  archiveRegistryRoots(
    "/unit-registry/property-units/archive-batch",
    "property_unit",
    unitIds,
    reason,
  )

export const restorePropertyUnitsBatch = (
  unitIds: string[],
): Promise<RegistryArchiveBatchResponse> =>
  restoreRegistryRoots("/unit-registry/property-units/restore-batch", "property_unit", unitIds)
